import { Button, ButtonSize, ButtonVariant } from "@amzn/stencil-react-components/button";
import { Chip, ChipBackgroundColor } from "@amzn/stencil-react-components/chip";
import {
  Expander,
  ExpanderChevronPosition,
  ExpanderTitleRendererParams,
} from "@amzn/stencil-react-components/expander";
import { Col, GridContainer, GridItem, Hr, Row } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import { IconGlobe, IconPadlock, IconPeople } from "@amzn/stencil-react-icons";
import ListModalButton from "common/components/ListModal/ListModalButton";
import { getString } from "common/uistringlabels/uiStringUtils";
import { ListModel, Visibility } from "lib/models/list-models";
import React, { FC } from "react";

import { ListItem } from "./ListItem";
import { useLists } from "./useLists";

export const List: FC<ListModel> = ({ name, description, visibility, itemCount, items, taxonomyId }) => {
  const { deleteList } = useLists();

  const renderVisibility = () => {
    switch (visibility) {
      case Visibility.PRIVATE:
        return (
          <Chip icon={<IconPadlock />} backgroundColor={ChipBackgroundColor.Purple}>
            {getString("lists.visibility.private")}
          </Chip>
        );
      case Visibility.PUBLIC:
        return (
          <Chip icon={<IconPeople />} backgroundColor={ChipBackgroundColor.Blue}>
            {getString("lists.visibility.public")}
          </Chip>
        );
      case Visibility.SHARED:
        return (
          <Chip icon={<IconGlobe />} backgroundColor={ChipBackgroundColor.Green}>
            {getString("lists.visibility.shared")}
          </Chip>
        );
      default:
        return visibility;
    }
  };

  const renderTitle = ({ titleText, toggle }: ExpanderTitleRendererParams) => {
    return (
      <Row width="100%" justifyContent="space-between">
        <Col onClick={toggle}>
          <Text fontSize="T300" fontWeight="bold" color="neutral90">
            {titleText}
          </Text>
          <Text fontSize="T200" color="neutral70">
            {description}
          </Text>
        </Col>
        <Row alignItems="center" gridGap="S300">
          <Chip>{getString("lists.itemCount", { itemCount })}</Chip>
          {renderVisibility()}
          <Button variant={ButtonVariant.Secondary} onClick={() => deleteList(taxonomyId)}>
            {getString("lists.deleteList")}
          </Button>
          <ListModalButton
            initialData={{ name, description, visibility }}
            taxonomyId={taxonomyId}
            isEdit={true}
            variant={ButtonVariant.Primary}
          />
        </Row>
      </Row>
    );
  };

  return (
    <>
      <Expander renderTitle={renderTitle} titleText={name} chevronPosition={ExpanderChevronPosition.Leading}>
        <GridContainer>
          {items.map((item, index) => (
            <GridItem lg={4} md={4} key={`${item.taxonomyId}-${index}`}>
              <ListItem item={item} />
            </GridItem>
          ))}
        </GridContainer>
      </Expander>
      <Hr />
    </>
  );
};
